import React, { useState } from "react";
import RangeDatePicker from "shared/components/rangeDatePicker";
import styles from "./style.module.scss";

function AccountsInFigure() {
  return (
    <div className={styles.mainCompContainer}>
      <Authors />
      <Publishers />
    </div>
  );
}

export default AccountsInFigure;

function Authors() {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  const authors = [
    {
      label: "Total Authors",
      value: 143382,
    },
    {
      label: "Approved  Authors",
      value: 87974,
    },
    {
      label: "Blocked Authors",
      value: 45211,
    },
    {
      label: "MOU Pending Authors",
      value: 21893,
    },
  ];
  return (
    <div className={styles.mainContainer}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>Accounts in Figures</div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <RangeDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            labelStyle={styles.dateLabel}
          />
        </div>
      </div>

      <div className={styles.progressContainer}>
        {authors?.map((item) => {
          return (
            <div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <label className={styles.heading}>{item?.label}</label>
                <label className={styles.barValue}>
                  {(item?.value).toLocaleString()}
                </label>
              </div>
              <progress
                value={item?.value}
                max={143382}
                className={styles.progressAuthor}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

function Publishers() {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  const authors = [
    {
      label: "Total Publishers ",
      value: 143382,
    },
    {
      label: "Approved  Publishers",
      value: 87974,
    },
    {
      label: "Blocked Publishers",
      value: 45211,
    },
    {
      label: "MOU Pending Publishers",
      value: 21893,
    },
  ];
  return (
    <div className={styles.mainContainer}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>Accounts in Figures</div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <RangeDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            labelStyle={styles.dateLabel}
          />
        </div>
      </div>

      <div className={styles.progressContainer}>
        {authors?.map((item) => {
          return (
            <div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <label className={styles.heading}>{item?.label}</label>
                <label className={styles.barValue}>
                  {(item?.value).toLocaleString()}
                </label>
              </div>
              <progress
                value={item?.value}
                max={143382}
                className={styles.progressPublisher}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
